/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class VitalSignRequest extends MainRequest{

    static addVitalSign(data) {
        return this.postSEC(ServicePath.VITAL_SIGN_ADD, data);
    }

    static listAllVitalSign(data) {
        return this.postSEC(ServicePath.VITAL_SIGN_LIST_ALL, data);
    }

    static findAllByPatientOrStudyOrMedicalPractice(data) {
        return this.postSEC(ServicePath.VITAL_SIGNS_ALL_BY_PATIENT_OR_STUDY_OR_MEDICAL_PRACTICE, data);
    }


}